module.exports = __webpack_public_path__ + "static/media/appstore-download.9e8a4fe8.png";